import { apiClient } from '@/hooks/useApi';

export interface BillingStatusDto {
  billingStatus: string;
  trialEndsOn: string | null;
  subscriptionRenewalOn: string | null;
  isSuspended: boolean;
  isTrialExpired: boolean;
}

export const billingApi = {
  async getStatus(): Promise<BillingStatusDto> {
    const { data } = await apiClient.get<BillingStatusDto>('/api/billing/status');
    return data;
  },
};
